import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchProjectCreation from './SearchProjectCreation';
import InviteConsultant from './InviteConsultant';
import SuggestedQualificationsModal from './SuggestedQualificationsModal';
import SuggestedMustHavesModal from './SuggestedMustHavesModal';
import { getRequest, postRequest } from '../../requestUtils';
import finalizeIcon from '../../../assets/images/finalize-icon.png';
import './EmployerInvitesConsultantToProjectModal.scss';
var EmployerInvitesConsultantToProjectModal = /*#__PURE__*/function (_Component) {
  function EmployerInvitesConsultantToProjectModal(props) {
    var _this;
    _classCallCheck(this, EmployerInvitesConsultantToProjectModal);
    _this = _callSuper(this, EmployerInvitesConsultantToProjectModal, [props]);
    _defineProperty(_this, "handleOpenQualManual", function () {
      _this.setState({
        showQualModal: true,
        useAISuggestions: false
      });
    });
    _defineProperty(_this, "handleSuggestUsingAI", function () {
      _this.setState({
        useAISuggestions: true
      });
      _this.fetchSuggestedTags();
    });
    _this.state = {
      currentPage: 'invite',
      project: null,
      projects: null,
      projectResourceId: null,
      // Track whether we just created a brand-new project in this flow
      creatingNewProject: false,
      isNewlyCreatedProject: false,
      // Suggested tags flow
      suggestedLoading: false,
      suggestedTags: {},
      showQualModal: false,
      showMustHaveModal: false,
      useAISuggestions: false
    };
    _this.handleInvited = _this.handleInvited.bind(_this);
    _this.redirectToFeaturedPage = _this.redirectToFeaturedPage.bind(_this);
    _this.redirectToProjectReview = _this.redirectToProjectReview.bind(_this);
    _this.redirectToHopOnACall = _this.redirectToHopOnACall.bind(_this);
    return _this;
  }
  _inherits(EmployerInvitesConsultantToProjectModal, _Component);
  return _createClass(EmployerInvitesConsultantToProjectModal, [{
    key: "setCurrentPageToInvite",
    value: function setCurrentPageToInvite() {
      this.setState({
        currentPage: 'invite',
        creatingNewProject: false
      });
    }
  }, {
    key: "mapSuggestedTagsToModels",
    value: function mapSuggestedTagsToModels(tags) {
      if (!tags) return {};
      var map = {
        'Functional Area': 'area_of_expertise',
        'Therapeutic Areas': 'therapeutic_area',
        'Product Technologies': 'therapy',
        'Product Tech': 'therapy',
        'Diseases/Indications': 'disease_code',
        'Phases of Development': 'development_phase',
        'Regulatory Pathway': 'regulatory_pathway',
        Skills: 'skill'
      };
      var out = {};
      Object.keys(tags).forEach(function (cat) {
        var m = map[cat];
        if (!m) return;
        out[m] = (tags[cat] || []).filter(Boolean);
      });
      return out;
    }
  }, {
    key: "fetchSuggestedTags",
    value: function () {
      var _fetchSuggestedTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var csrfToken, projectResourceId, resp, data, payload, sresp, sdata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              csrfToken = this.props.csrfToken;
              projectResourceId = this.state.projectResourceId;
              if (projectResourceId) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              this.setState({
                suggestedLoading: true
              });
              _context.prev = 5;
              _context.next = 8;
              return getRequest("/projects/".concat(projectResourceId, "?form_step=review"));
            case 8:
              resp = _context.sent;
              data = resp && resp.data ? resp.data : {};
              payload = {
                title: data.name,
                description: data.description,
                ideal_candidate_description: data.ideal_candidate_description,
                responsibilities: data.responsibility_areas || []
              };
              _context.next = 13;
              return postRequest('/projects/suggest_tags', payload, csrfToken);
            case 13:
              sresp = _context.sent;
              sdata = sresp && sresp.data ? sresp.data : {};
              this.setState({
                suggestedTags: sdata.tags || {},
                suggestedLoading: false,
                showQualModal: true,
                useAISuggestions: true
              });
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](5);
              this.setState({
                suggestedLoading: false,
                suggestedTags: {}
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 18]]);
      }));
      function fetchSuggestedTags() {
        return _fetchSuggestedTags.apply(this, arguments);
      }
      return fetchSuggestedTags;
    }()
  }, {
    key: "setCurrentPageToQuestions",
    value: function setCurrentPageToQuestions() {
      this.setState({
        currentPage: 'questions',
        creatingNewProject: true
      });
    }
  }, {
    key: "handleInvited",
    value: function handleInvited(projectResourceId) {
      var creatingNewProject = this.state.creatingNewProject;
      this.setState({
        currentPage: 'invite-more',
        projectResourceId: projectResourceId,
        isNewlyCreatedProject: !!creatingNewProject,
        creatingNewProject: false
      });
    }
  }, {
    key: "redirectToFeaturedPage",
    value: function redirectToFeaturedPage() {
      var filters = this.props.filters;
      if (!filters) {
        window.location.href = '/featured';
      } else {
        var filteredFilters = Object.fromEntries(Object.entries(filters).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            _ = _ref2[0],
            value = _ref2[1];
          return value !== null;
        }));
        // Construct the URLSearchParams
        var refinementList = new URLSearchParams();
        Object.entries(filteredFilters).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          if (Array.isArray(value)) {
            value.forEach(function (v, index) {
              refinementList.append("".concat(key, "[").concat(index, "]"), v);
            });
          } else {
            refinementList.append(key, value);
          }
        });
        window.location.href = "/featured?".concat(refinementList.toString());
      }
    }
  }, {
    key: "redirectToProjectReview",
    value: function redirectToProjectReview() {
      var projectResourceId = this.state.projectResourceId;
      window.location.href = "/projects/".concat(projectResourceId, "/edit");
    }
  }, {
    key: "redirectToHopOnACall",
    value: function redirectToHopOnACall() {
      var projectResourceId = this.state.projectResourceId;
      var currentUser = this.props.currentUser;
      var queryParams = new URLSearchParams({
        firstname: currentUser.firstName,
        lastname: currentUser.lastName,
        email: currentUser.email,
        current_last_company_name__c: currentUser.companyName,
        sales_intake_description__c: "/projects/".concat(projectResourceId)
      });
      var salesBookingLink = "https://clora.na.chilipiper.com/book/clora?".concat(queryParams.toString());
      window.open(salesBookingLink, '_blank');
    }
  }, {
    key: "renderPage",
    value: function renderPage() {
      var _this2 = this;
      var _this$state = this.state,
        currentPage = _this$state.currentPage,
        projects = _this$state.projects,
        project = _this$state.project;
      var _this$props = this.props,
        consultant = _this$props.consultant,
        workLocationOptions = _this$props.workLocationOptions,
        durationOptions = _this$props.durationOptions,
        timePerWeekOptions = _this$props.timePerWeekOptions,
        csrfToken = _this$props.csrfToken,
        query = _this$props.query,
        fromProject = _this$props.fromProject,
        filters = _this$props.filters;
      if (currentPage === 'invite-more') {
        var _this$state2 = this.state,
          projectResourceId = _this$state2.projectResourceId,
          suggestedLoading = _this$state2.suggestedLoading,
          suggestedTags = _this$state2.suggestedTags,
          useAISuggestions = _this$state2.useAISuggestions,
          isNewlyCreatedProject = _this$state2.isNewlyCreatedProject;
        return /*#__PURE__*/React.createElement("div", {
          className: "invite-more"
        }, /*#__PURE__*/React.createElement("div", {
          className: "success-message"
        }, /*#__PURE__*/React.createElement("div", {
          className: "consultant-detail g-row--always"
        }, /*#__PURE__*/React.createElement("span", {
          role: "img",
          "aria-labelledby": "party popper",
          className: "party-popper mr-20"
        }, "\uD83C\uDF89"), /*#__PURE__*/React.createElement("div", {
          className: "consultant-detail"
        }, /*#__PURE__*/React.createElement("h3", null, "Congrats! Your proposal request has been sent to ".concat(consultant.first_name, "."))))), /*#__PURE__*/React.createElement("div", {
          className: "invite-more-message"
        }, /*#__PURE__*/React.createElement("h1", null, "Find the perfect talent even faster!"), /*#__PURE__*/React.createElement("div", {
          className: "message-body"
        }, /*#__PURE__*/React.createElement("div", {
          className: "g-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "left-side g-flex-25"
        }, /*#__PURE__*/React.createElement("img", {
          src: finalizeIcon,
          alt: "talk to clora"
        })), /*#__PURE__*/React.createElement("div", {
          className: "right-side g-flex-70"
        }, /*#__PURE__*/React.createElement("div", null, "Boost your visibility by finalizing your requirements now and tap into our network of 11,000+ top-tier consultants."), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Draw the right talent with a detailed description."), /*#__PURE__*/React.createElement("li", null, "Expedite your search by letting consultants self-qualify."), /*#__PURE__*/React.createElement("li", null, "Help us to pre-screen candidates to reduce noise.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary",
          onClick: this.redirectToProjectReview
        }, "Finalize Project Requirements")), /*#__PURE__*/React.createElement("div", {
          className: "continue-action"
        }, /*#__PURE__*/React.createElement("a", {
          role: "button",
          onClick: this.redirectToFeaturedPage,
          tabIndex: 0
        }, "Continue to browse"))))), /*#__PURE__*/React.createElement("div", {
          className: "message-footer mb-4"
        }, /*#__PURE__*/React.createElement("strong", null, "Need a hand?"), "\xA0 Our team is here to ensure you find your ideal consultant fast. You an use the chat below, or \xA0", /*#__PURE__*/React.createElement("a", {
          tabIndex: 0,
          role: "button",
          onClick: this.redirectToHopOnACall
        }, "hop on a call with us.")), isNewlyCreatedProject && /*#__PURE__*/React.createElement("div", {
          className: "mt-4"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 medium-weight mb-2"
        }, "Qualifications"), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2 align-items-center"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary standard-button half-spacing",
          onClick: this.handleOpenQualManual,
          disabled: !projectResourceId
        }, "Add qualifications"), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary standard-button half-spacing",
          onClick: this.handleSuggestUsingAI,
          disabled: !projectResourceId || suggestedLoading
        }, suggestedLoading ? 'Suggesting…' : 'Suggest using AI')), /*#__PURE__*/React.createElement(SuggestedQualificationsModal, {
          isOpen: this.state.showQualModal,
          onClose: function onClose() {
            return _this2.setState({
              showQualModal: false
            });
          },
          onSaved: function onSaved() {
            return _this2.setState({
              showQualModal: false,
              showMustHaveModal: true
            });
          },
          projectResourceId: projectResourceId,
          csrfToken: csrfToken,
          suggestedTagLabels: useAISuggestions ? this.mapSuggestedTagsToModels(suggestedTags) : undefined
        }), /*#__PURE__*/React.createElement(SuggestedMustHavesModal, {
          isOpen: this.state.showMustHaveModal,
          onClose: function onClose() {
            return _this2.setState({
              showMustHaveModal: false
            });
          },
          onSaved: function onSaved() {
            return _this2.setState({
              showMustHaveModal: false
            });
          },
          projectResourceId: projectResourceId,
          csrfToken: csrfToken
        }))));
      }
      if (currentPage === 'questions') {
        return /*#__PURE__*/React.createElement(SearchProjectCreation, {
          consultant: consultant,
          project: project,
          backToProjectSelection: function backToProjectSelection() {
            return _this2.setCurrentPageToInvite();
          },
          handleInvited: function handleInvited(resourceId) {
            return _this2.handleInvited(resourceId);
          },
          workLocationOptions: workLocationOptions,
          durationOptions: durationOptions,
          timePerWeekOptions: timePerWeekOptions,
          csrfToken: csrfToken,
          query: query,
          filters: filters
        });
      }
      if (currentPage === 'invite') {
        return /*#__PURE__*/React.createElement(InviteConsultant, {
          consultant: consultant,
          projects: projects,
          project: project,
          defaultProjectId: fromProject,
          csrfToken: csrfToken,
          goToQuestions: function goToQuestions() {
            return _this2.setCurrentPageToQuestions();
          },
          handleInvited: function handleInvited(resourceId) {
            return _this2.handleInvited(resourceId);
          },
          query: query
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "employer-invites-consultant-to-project modal-dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, this.renderPage())));
    }
  }]);
}(Component);
EmployerInvitesConsultantToProjectModal.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.instanceOf([])]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.instanceOf([])]).isRequired,
  query: PropTypes.number,
  fromProject: PropTypes.string,
  filters: PropTypes.shape({}),
  currentUser: PropTypes.shape({})
};
EmployerInvitesConsultantToProjectModal.defaultProps = {
  query: null,
  fromProject: null,
  filters: {},
  currentUser: {}
};
export default EmployerInvitesConsultantToProjectModal;